import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

const Address = ({
  fullName,
  company,
  addressLine1,
  addressLine2,
  postalCode,
  city,
  country,
  administrativeArea,
}) => (
  <>
    {company && <Typography variant="body2">{company}</Typography>}
    {fullName && <Typography variant="body2">{fullName}</Typography>}
    {addressLine1 && <Typography variant="body2">{addressLine1}</Typography>}
    {addressLine2 && <Typography variant="body2">{addressLine2}</Typography>}
    {(postalCode || city || country || administrativeArea) && (
      <Typography variant="body2">
        {`${postalCode} ${city}${administrativeArea ? ` ${administrativeArea}` : ''}${
          country && `, ${country}`
        }`}
      </Typography>
    )}
  </>
);

Address.propTypes = {
  administrativeArea: PropTypes.string,
  fullName: PropTypes.string,
  company: PropTypes.string,
  addressLine1: PropTypes.string,
  addressLine2: PropTypes.string,
  postalCode: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
};

Address.defaultProps = {
  administrativeArea: undefined,
  fullName: undefined,
  company: undefined,
  addressLine1: undefined,
  addressLine2: undefined,
  postalCode: undefined,
  city: undefined,
  country: undefined,
};

export default Address;
